import { IonicInput } from 'ionic-ui';
import { useFormContext, Controller } from 'react-hook-form';
import { WalletIndividualKyc } from '../../../../../../../schemas/wallet-individual-kyc-schema';

export const IndividualSecurityDialog = () => {
  const { control } = useFormContext<WalletIndividualKyc>();

  return (
    <div>
      <h6 className="medium-emphasis-text font-medium">
        Verify your National Identification Number
      </h6>
      <p className="medium-emphasis-text py-2">
        Enter the NIN tied to the person creating this wallet.
      </p>
      <div className="py-4 gap-4">
        <Controller
          name="nin"
          control={control}
          render={({ field, fieldState }) => (
            <IonicInput
              {...field}
              label="NIN*"
              placeholder="Enter 11-digit NIN"
              max={11}
              hint={fieldState.error?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
        <Controller
          name="bvn"
          control={control}
          render={({ field, fieldState }) => (
            <IonicInput
              {...field}
              label="BVN*"
              placeholder="Enter 11-digit BVN"
              max={11}
              hint={fieldState.error?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
      </div>
    </div>
  );
};
